import { MediaDevice } from './mediaDevice';

export type AssignedCamera = {
    tag?: MediaDevice.Tag;
    mirror?: boolean;
    upsidedown?: boolean;
}

export type AssignedMicrophone = {
    tag?: MediaDevice.Tag;
}

export type MainScreenLayout = {
    center: AssignedCamera[];
    top: AssignedCamera[];
    left: AssignedCamera[];
    right: AssignedCamera[];
    microphone?: AssignedMicrophone;
}

export type SubScreenLayout = {
    center: AssignedCamera[];
    top: AssignedCamera[];
    bottom: AssignedCamera[];
}

export type VehicleCameraLayout = {
    mainscreen: MainScreenLayout;
    subscreens: SubScreenLayout[];
}

function equalArray(a: AssignedCamera[], b: AssignedCamera[]) {
    function equalCamera(a: AssignedCamera, b: AssignedCamera) {
        return a.tag === b.tag
            && a.mirror === b.mirror
            && a.upsidedown === b.upsidedown
            ;
    }
    return a.length === b.length
        && a.find((a, i) => !equalCamera(a, b[i])) === undefined;
}

function equalMainscreen(a: MainScreenLayout, b: MainScreenLayout) {
    function equalMicrophone(a: AssignedMicrophone | undefined, b: AssignedMicrophone | undefined) {
        return (a === undefined && b === undefined)
            || (a !== undefined && b !== undefined
                && a.tag === b.tag)
            ;
    }

    if (a === b) return true;

    return equalArray(a.center, b.center)
        && equalArray(a.top, b.top)
        && equalArray(a.left, b.left)
        && equalArray(a.right, b.right)
        && equalMicrophone(a.microphone, b.microphone)
        ;
}

function equalSubscreen(a: SubScreenLayout, b: SubScreenLayout) {
    if (a === b) return true;

    return equalArray(a.center, b.center)
        && equalArray(a.top, b.top)
        && equalArray(a.bottom, b.bottom)
        ;
}

function equalSubscreens(as: SubScreenLayout[], bs: SubScreenLayout[]) {
    return as.length === bs.length
        && as.find((a, i) => equalSubscreen(a, bs[i])) === undefined;
}

export function equalLayout(a: VehicleCameraLayout, b: VehicleCameraLayout) {
    if (a === b) return true;

    return equalMainscreen(a.mainscreen, b.mainscreen)
        && equalSubscreens(a.subscreens, b.subscreens)
        ;
}
